module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "views_from_the_o_mobile.b9294b70.webp";